import Vue from "vue"
import Router from "vue-router"
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [{
            path: "/",
            redirect: "/home"
        },
        {
            path: "/layout",
            name: "layout",
            redirect: "/home",
            component: () => import ("@/view/layout/layout"),
            children: [{
                    path: "/home",
                    name: "home",
                    component: () =>
                        import ("@/view/home/home"),
                    meta: []
                },
                {
                    path: "/visaItems",           //服务
                    name: "visaItems",
                    component: () =>
                        import ("@/view/visaItems/visaItems"),
                    meta: []
                },
                {
                    path: "/faq",           //常问问题 
                    name: "faq",
                    component: () =>
                        import ("@/view/faq/faq"),
                    meta: []
                },
                {
                    path: "/contacts",      //联系我们
                    name: "contacts",
                    component: () =>
                        import ("@/view/contacts/contacts"),
                    meta: []
                },
            ]
        },
    ],

})
export default router
